import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { localize, formatPrice } from '../data/mock';
import { useLang } from '../context/LanguageContext';

const PropertyCard = ({ property }) => {
  const { lang, t } = useLang();
  const p = property;
  const isLiquidation = p.category === 'liquidation';

  return (
    <Link to={`/bien/${p.id}`} className="group block">
      <div className="img-zoom relative aspect-[4/3] bg-[#eae2d3]">
        <img
          src={p.images[0]}
          alt={localize(p.title, lang)}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4 flex gap-2">
          <span className="bg-[#1b2331]/85 backdrop-blur-sm text-[#f4efe6] font-sans-elegant text-[0.6rem] tracking-wide-2 uppercase px-3 py-1.5">
            {p.country}
          </span>
          {isLiquidation && (
            <span className="bg-[#b0894f] text-[#f4efe6] font-sans-elegant text-[0.6rem] tracking-wide-2 uppercase px-3 py-1.5">
              {localize(p.status, lang)}
            </span>
          )}
        </div>
        <div className="absolute inset-0 bg-[#1b2331]/0 group-hover:bg-[#1b2331]/10 transition-colors duration-500" />
      </div>

      <div className="pt-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-sans-elegant text-[0.62rem] tracking-brand uppercase text-[#b0894f] mb-2">
              {localize(p.location, lang)}
            </p>
            <h3 className="font-serif-display text-2xl text-[#1b2331] leading-tight group-hover:text-[#b0894f] transition-colors duration-300">
              {localize(p.title, lang)}
            </h3>
          </div>
          <ArrowUpRight className="w-5 h-5 text-[#1b2331] opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 shrink-0 mt-1" />
        </div>

        <p className="font-sans-elegant text-sm text-[#5a5d63] mt-3 leading-relaxed line-clamp-2">
          {localize(p.excerpt, lang)}
        </p>

        <div className="flex items-center justify-between mt-4 pt-4 border-t border-[#1b2331]/10">
          <span className="font-sans-elegant text-sm text-[#1b2331]">
            {p.price ? formatPrice(p.price, lang) : t('detail.onRequest')}
          </span>
          {p.surface && (
            <span className="font-sans-elegant text-xs text-[#8a8d93]">
              {p.surface.toLocaleString(lang === 'en' ? 'en-US' : 'fr-FR')} m²
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default PropertyCard;
